import { Modal } from "antd";
import { Button } from "antd";
import React, { FC } from "react";
import BillingDetails from "../../Discharge/IHX/IHXTabs/BillingDetails";
import EnhancementIhxBasicDetails from "./EnhancementIhxBasicDetails";
import DocumentUploadEnhancement from "./DocumentUploadEnhancement";
import EnhancementIhxBillingDetails from "./EnhancementIhxBillingDetails";
import { Document } from "../../PreAuth/PreAuthIhx/PreAuthIhx";

type EnhancementIhxProps = {
  form: any;
  createEnhancement: boolean;
  closeCreateEnhancementModal: any;
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  handleSubmit: any;
  isSubmitting: boolean;
};

const EnhancementIhx: FC<EnhancementIhxProps> = ({
  form,
  createEnhancement,
  closeCreateEnhancementModal,
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  handleSubmit,
  isSubmitting
}) => {
  return (
    <Modal
      title={
        <div>
          <span style={{ fontSize: "1rem", fontWeight: "600" }}>
            NEW ENHANCEMENT
          </span>
        </div>
      }
      centered
      width={2000}
      footer={[
        <Button
          key="update"
          // loading={props?.isLoading}
          className="update-btn"
          htmlType="submit"
          form="new-enhancement-form"
          style={{
            backgroundColor: "#008B8B",
            color: "white",
            fontWeight: 600,
            fontSize: "0.8rem",
            borderRadius: "50px",
            boxShadow: "inset 0px -3px 4px 0px #00000040",
            // padding: "0 20px",
            // height: "48px",
            border: "none",
          }}
          onClick={handleSubmit}
          loading={isSubmitting}
        >
          Save
        </Button>,
      ]}
      open={createEnhancement}
      onCancel={closeCreateEnhancementModal}
      style={{ boxShadow: "0px 4px 20px 0px #00000040", width: "149%" }}
      className="new-enhancement-ihx"
    >
      <EnhancementIhxBasicDetails form={form} />
      <EnhancementIhxBillingDetails form={form} />
      <DocumentUploadEnhancement
        documentTypes={documentTypes}
        documentUrls={documentUrls}
        handleFileChange={handleFileChange}
        handleOpen={handleOpen}
      />
    </Modal>
  );
};

export default EnhancementIhx;
